export const formatDurationTag = (seconds: number): string => {
  if (!seconds) { return ''; }

  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  // Round minutes if secs >= 30
  if (secs >= 30) { minutes++; }

  if (minutes >= 60) {
    hours++;
    minutes = 0;
  }

  if (hours === 0) {
    if (seconds < 60) { return `${secs} sec`; }
    return minutes >= 60 ? '1 hr' : `${minutes} min`;
  }

  return minutes === 0 ? `${hours} hr` : `${hours} hr ${minutes} min`;
};


/**
 * @param duration Duration in seconds
 *
 * Calculates hours and minutes into a string
 * Hours are only shown if at least 1
 * Minutes get rounded
 *
 * @returns string, such as '2hrs 24min' or '31min'
 */

export const formatDuration = (duration: number) => {
  if (!duration) { return ''; }

  const hours = Math.floor(duration / 3600);
  const minutes = Math.round((duration - hours * 3600) / 60);

  const hoursString = hours ? `${hours}hrs ` : '';
  const minutesString = minutes ? `${minutes}min ` : '';

  return `${hoursString}${minutesString}`;
};

export const formatPrice = (price: number, currency: string, country?: string) => {
  return new Intl.NumberFormat(country || 'en-US', {
    style: 'currency',
    currency,
  }).format(price);
};

export const cleengFormatPrice = (price: number, currency: string, country?: string) => {
  const locale = country === 'IN' ? 'en-IN' : 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

export const formatSeriesMetaString = (seasonNumber?: string, episodeNumber?: string) => {
  if (!seasonNumber && !episodeNumber) {
    return '';
  }

  return seasonNumber && seasonNumber !== '0' ? `S${seasonNumber}:E${episodeNumber}` : `E${episodeNumber}`;
};

export const formatSeriesMetaStringLabel = (seasonNumber?: string, episodeNumber?: string) => {
  if (!seasonNumber && !episodeNumber) {
    return '';
  }

  return seasonNumber && seasonNumber !== '0' ? ` S${seasonNumber} E${episodeNumber}` : ` E${episodeNumber}`;
};

export const formatVideoSchedule = (locale: string, scheduledStart?: Date, scheduledEnd?: Date) => {
  if (!scheduledStart) {
    return '';
  }

  if (!scheduledEnd) {
    return formatLocalizedDateTime(scheduledStart, locale, ' • ');
  }

  return `${formatLocalizedDateTime(scheduledStart, locale, ' , ')}`;
  // return `${formatLocalizedDateTime(scheduledStart, locale, ' , ')} - ${formatLocalizedDateTime(scheduledEnd, locale)}`;
};

export const formatLocalizedDate = (dateInput: Date, locale: string) => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

  const today = new Date();
  if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()) {
    return 'Today';
  }
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
};

export const formatLocalizedTime = (date: Date, locale: string) => {
  return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: 'numeric' }).format(date);
};

export const formatLocalizedDateTime = (dateInput: Date, locale: string, separator = ' ') => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

  return `${formatLocalizedDate(date, locale)}`;
  // return `${formatLocalizedDate(date, locale)}${separator}${formatLocalizedTime(date, locale)}`;
};


export const formatAmount = (amount: string | number): string => {
  const num = parseFloat(amount.toString());
  return num.toFixed(2);
};
